export const MEGVALOSITAS_ERTEKELES_TRANSLATIONS = {
    hu: {
        pageTitle: "15. Fejlesztési javaslatok megvalósítása és értékelése",
        description: "Kérjük értékelje az előző jelentésben megfogalmazott fejlesztési javaslatok megvalósítását",
        
        buttons: {
            previous: "Előző szakasz",
            next: "Következő szakasz",
            save: "Mentés",
            finalize: "Véglegesítés",
            unfinalize: "Véglegesítés visszavonása"
        },
        
        alerts: {
            requiredFields: "Minden mezőt ki kell tölteni!"
        },
        
        sidebar: [
            "Szak alapadatok",
            "A képzés",
            "A szak mintatanterve",
            "Tehetséges, kiemelkedő hallgatói teljesítmények",
            "Idegen nyelvi követelmények",
            "Kötelező szakmai gyakorlat",
            "Mintatanterv fejlesztések, módosítások",
            "Fejlesztési javaslatok",
            "Oktatás",
            "A szak hallgatóira vonatkozó adatok",
            "Versenytárs elemzés",
            "Meghívott előadók és óraadók",
            "Oktatók értékelése",
            "A képzés tanulmányi körülményei",
            "A szak kommunikációja",
            "Fejlesztési javaslatok megvalósítása és értékelése",
            "Szakjelentés lezárása"
        ]
    },
    en: {
        pageTitle: "15. Implementation and evaluation of development proposals",
        description: "Please evaluate the implementation of the development proposals set out in the previous report",
        
        buttons: {
            previous: "Previous Section",
            next: "Next Section",
            save: "Save",
            finalize: "Finalize",
            unfinalize: "Revert Finalization"
        },
        
        alerts: {
            requiredFields: "All fields must be filled in!"
        },
        
        sidebar: [
            "Programme Basic Data",
            "The Programme",
            "Programme Curriculum",
            "Talented Students and Outstanding Student Performance",
            "Foreign Language Requirements",
            "Compulsory Professional Practice",
            "Curriculum Developments and Modifications",
            "Development Recommendations",
            "Teaching",
            "Data related to the major",
            "Competitor Analysis",
            "Guest Lecturers and Part-time Teachers",
            "Assessment of Teachers",
            "Study Conditions",
            "Programme Communication",
            "Implementation and Evaluation of Development Recommendations",
            "Finalisation of Programme Report"
        ]
    }
};
